import { useCallback, useMemo, useState } from 'react';
import { ApiService } from 'api';
import { MeasurementDate } from 'common/types/measurementDate';
import { useResponse } from 'services/hooks';
import { Logger } from 'utilities';

const useEnqueueIndividualCompanyReports = (
  enqueueToTrigger: Set<number>,
  firmId: number | null,
  selectedReportDate: MeasurementDate | null,
  setEnqueueToTrigger: React.Dispatch<React.SetStateAction<Set<number>>>,
  isConcreteDateSelectedForReport: boolean // to determine if we should send the date in the API call
) => {
  const { errorNotification } = useResponse();
  const [isLoading, setIsLoading] = useState(false);

  const enqueueButtonHandler = useCallback(async () => {
    setIsLoading(true);
    const payload = {
      company_measurement_dates: Array.from(enqueueToTrigger),
      firm: firmId!,
      target_failed: true,
    };
    try {
      await ApiService.apiExcelExportsFullCompanyReportsByDateCreate(
        firmId!.toString(),
        payload,
        isConcreteDateSelectedForReport ? selectedReportDate!.date : undefined
      );
      setEnqueueToTrigger(new Set());
    } catch (error) {
      errorNotification('Error enqueuing individual company reports.');
      Logger.error('Error enqueuing individual company reports.', error);
    } finally {
      setIsLoading(false);
    }
  }, [
    enqueueToTrigger,
    firmId,
    selectedReportDate,
    errorNotification,
    setEnqueueToTrigger,
    isConcreteDateSelectedForReport,
  ]);

  const enqueueButtonHandlerIsDisabled = useMemo(
    () => enqueueToTrigger.size === 0 || isLoading,
    [enqueueToTrigger, isLoading]
  );
  return { enqueueButtonHandler, isLoading, setIsLoading, enqueueButtonHandlerIsDisabled };
};
export default useEnqueueIndividualCompanyReports;
